import { useMutation, useQueryClient } from '@tanstack/react-query';

import { notifyMeta } from '@/lib/notify';
import { STAFF_KEYS } from '@/constants/queryKeys';
import { authService } from '@/services/auth';
import { errorUtils } from '@/services/errors';

type TVerifyTotpPayload = {
  factorID: string;
  code: string;
};

const useVerifyTotp = () => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, TVerifyTotpPayload>({
    meta: notifyMeta('authTotpVerify'),
    mutationFn: async ({ factorID, code }) => {
      errorUtils.unwrap(await authService.verifyTotp(factorID, code));

      await queryClient.invalidateQueries({ queryKey: STAFF_KEYS.root });
    },
  });
};

export type {
  TVerifyTotpPayload,
};
export {
  useVerifyTotp,
};
